import { ConfigStorage } from '@config/index';

interface ICreatedProvider {
  id: string;
  name: string;
  cellphone: string;
  cpf_cnpj: string;
  person_type: string;
  status: string;
  email: string;
}

interface ICreatedAddress {
  zip_code: string;
  street: string;
  city: string;
  state: string;
  number: string;
  country: string;
  complement: string;
  neighborhood: string;
}

interface IHours {
  saturday: string;
  sunday: string;
  util_day: string;
}

interface IServices {
  label: string;
  value: boolean;
  text: string;
}

interface ICreateService {
  openingHours: IHours;
  selectedHourType: string;
  selectedServices: IServices[];
}

interface IService extends IResumedService {
  stopped_hour: number;
  worked_hour: number;
}

interface IResumedService {
  exit_km: number;
  over_km: number;
}
interface ICreatePrice extends IHours {
  reboque_car?: IService;
  reboque_moto?: IService;
  reboque_suv?: IService;
  battery_recharge?: IResumedService;
  keychain?: IResumedService;
  drypan?: IResumedService;
  tire_change?: IResumedService;
  selectedHourType: string;
}

const getProvider = (key: string): string | null => {
  const storageProvider = sessionStorage.getItem(key);
  return storageProvider;
};

const updateProvider = (data: ICreatedProvider): void => {
  sessionStorage.setItem(
    ConfigStorage.REBOX_REGISTER_NEW_PROVIDER,
    JSON.stringify(data),
  );
};

const getAddresses = (key: string): string | null => {
  const storageAddresses = sessionStorage.getItem(key);
  return storageAddresses;
};

const updateAddresses = (data: ICreatedAddress[]): void => {
  sessionStorage.setItem(
    ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_ADDRESS,
    JSON.stringify(data),
  );
};

const getServices = (key: string): string | null => {
  const storageServices = sessionStorage.getItem(key);
  return storageServices;
};

const updateServices = (data: ICreateService): void => {
  sessionStorage.setItem(
    ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_SERVICE,
    JSON.stringify(data),
  );
};

const getPrices = (key: string): string | null => {
  const storagePrices = sessionStorage.getItem(key);
  return storagePrices;
};

const updatePrices = (data: ICreatePrice): void => {
  sessionStorage.setItem(
    ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_PRICE,
    JSON.stringify(data),
  );
};

const cleanMany = (): void => {
  sessionStorage.removeItem(ConfigStorage.REBOX_REGISTER_NEW_PROVIDER);
  sessionStorage.removeItem(ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_ADDRESS);
  sessionStorage.removeItem(ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_SERVICE);
  sessionStorage.removeItem(ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_PRICE);
};

export default {
  getProvider,
  getAddresses,
  updateProvider,
  updateAddresses,
  getServices,
  updateServices,
  getPrices,
  updatePrices,
  cleanMany,
};
